namespace GeniuzPOS.Customer {
    export class CsCustGroupColumns {
        static columnsKey = 'Customer.CsCustGroup';
    }
}
